import { clear } from "console";
import * as dotenv from "dotenv";

dotenv.config();

const API_PREFIX = "/api";

export const MY_SELLER_BUCKET_PRE_URL = process.env.REACT_APP_MY_SELLER_BUCKET_PRE_URL;
export const ABOUT_PAGE_BUCKET_PRE_URL = process.env.REACT_APP_ABOUT_PAGE_BUCKET_PRE_URL;
export const TERMS_DEFAULT_FILE = "sample.pdf";

export const CESIUM_API_TOKEN =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiI5YTZkNzU1OS01MGY1LTQxZTUtODQ2Ni02MTkwZjY3NmU1MDIiLCJpZCI6ODg4NTQsImlhdCI6MTY0OTQyNzY4NH0.aXUgsiZW-GGeaIdcCv4PtEylZQD-ekbKcnMD9ZUGQdM";
export const API_URL = process.env.REACT_APP_API_BASE_URL;

export const ApiPath = {
  requestQuote: `${API_PREFIX}/web-form`,
  login: `${API_PREFIX}/login`,
  users: `${API_PREFIX}/users`,
  getUserData: `/get-user-data`,
  getUserDataById: `/get-user-data-by-id`,
  updateUserInformation: `/update-user-information`,
  updateUserInformationById: `/update-user-information-by-id`,
  getUserOrganization: `/get-user-organization`,
  getOrganizations: `/get-organizations`,
  role: "/role",
  transaction: `${API_PREFIX}/transaction`,
  getWXPayReport: "/get-wx-pay-report",
  getWXPaySummary: "/get-wx-pay-summary",
  validateUser: "/validate-user",
  selectedNode: "/selected-node",
  networkResources: `${API_PREFIX}/network-resources`,
  networkElements: "/network-elements",
  portTypes: "/port-types",
  validatePort: "/validate-nr",
  movePort: "/move-nr",
  getManagePortsList: "/get-manage-ports-list",
  canvasPosition: "/canvas-position",
  updateCanvasPosition: "/update-canvas-position",
  saveCanvasPosition: "/save-canvas-position",
  getSavedCanvasPosition: "/get-saved-canvas-position",
  clearSavedCanvasPosition: "/clear-saved-canvas-position",
  nodeWiseNr: "/nodewise-nr",
  bandwidth: `${API_PREFIX}/bandwidth`,
  bandwidthPortList: "/nr-list",
  group: `${API_PREFIX}/group`,
  bandwidthGroup: `${API_PREFIX}/bandwidth/group`,
  nrList: "/nr-list",
  editBandwidth: `${API_PREFIX}/bandwidth/edit-bandwidth`,
  putForSale: `${API_PREFIX}/virtual-port`,
  manageBandwidthList: `${API_PREFIX}/bandwidth/getManageBandwidthList`,
  myNetworkBandwidthList: `${API_PREFIX}/bandwidth/my-network-details`,
  myNetworkBandwidthListWithoutFilters: `${API_PREFIX}/bandwidth/my-network`,
  putupBandwidthForSale: `${API_PREFIX}/virtual-port/bandwidthLinkForSale`,
  marketplaceAllBandwidthList: `${API_PREFIX}/virtual-port/get-bandwidthlist-for-purchase`,
  purchaseBandwidth: `${API_PREFIX}/purchase-resources/purchase-bandwidth`,
  purchaseResource: `${API_PREFIX}/purchase-resources`,
  editBandiwdthSaleDetail: `${API_PREFIX}/virtual-port/edit-virtualports-for-bandwidth`,
  removeBandwidthFromMarketplace: `${API_PREFIX}/virtual-port/delete-virtualports-for-bandwidth`,
  getBandwidthListForMap: `${API_PREFIX}/virtual-port/bandwidthlist-for-mapview`,
  crossConnect: `${API_PREFIX}/cross-connect`,
  cancelSubscription: `${API_PREFIX}/network-resources/cancel-subscription`,
  cancelSubscriptionBandwidth: `${API_PREFIX}/bandwidth/cancel-bandwidth`,
  setRequestVerification: `${API_PREFIX}/network-resources/set-request-verification`,
  getDeletePortList: `${API_PREFIX}/network-resources/get-delete-port-list`,
  deletePort: `${API_PREFIX}/network-resources/delete-port`,
  deleteOffNetPort: `${API_PREFIX}/network-resources/delete-off-net-port`,
  getAvailablePortsOnSwitch: `${API_PREFIX}/network-resources/port-on-switch`,
  getDeleteBandwidthPortList: `${API_PREFIX}/bandwidth/bandwidth-list`,
  deleteBandwidth: `${API_PREFIX}/bandwidth/delete-bandwidth`,
  deleteOffNetBandwidth: `${API_PREFIX}/bandwidth/delete-off-net-bandwidth`,
  aboutMenus: `${API_PREFIX}/about-menus`,
  editNR: `${API_PREFIX}/network-resources/edit-nr`,
  addNE: `${API_PREFIX}/network-element`,
  editNE: `${API_PREFIX}/network-element/edit`,
  actionController: `${API_PREFIX}/action-controller`,
  privateNodeRequest: `${API_PREFIX}/private-node-request`,
  newUserPrivateNodeRequest: `${API_PREFIX}/private-node-request/new-user`,
  getPrivateNodeRequestStatus: `${API_PREFIX}/private-node-request/get-private-node-request-status`,
  updatePrivateNodeRequestStatus: `${API_PREFIX}/private-node-request/update-private-node-request-status`
};
export const API_PATHS_NEW = {
  crossConnectActionRequired: `${ApiPath.actionController}/cross-connect-action-required`,
  portViewDetails: `${ApiPath.networkResources}/port-view-details`,
  moveToLeasedSwitch: `${ApiPath.networkResources}/move-to-leased-switch`,
  removeFromLeasedSwitch: `${ApiPath.networkResources}/remove-from-leased-switch`,
  movePositionOnLeasedSwitch: `${ApiPath.networkResources}/move-position-on-leased-switch`,
  getAvailablePositionsOnLeasedSwitch: `${ApiPath.networkResources}/get-available-positions-on-leased-switch`,
  getPotentialNetworkResourceRolls: `${ApiPath.putForSale}/get-potential-network-resource-rolls`,
  rollTrafficNetworkResource: `${ApiPath.putForSale}/roll-traffic-network-resource`,
  rollTrafficBandwidth: `${ApiPath.putForSale}/roll-traffic-bandwidth`,
  getPortsInGroup: `${ApiPath.group}/get-ports-in-group`,
  requestMoveToMMR: `${ApiPath.networkResources}/request-move-to-mmr`,
};

export const ErrorCodeMessageMapping = {
  1001: "Email must be unique.",
  1002: "Username must be unique.",
  1003: "Username or password are not matching. Kindly provide valid details.",
  1006: "Not enough ports available. Please contact WaveXchange for further support.",
  1007: "Port Name is not valid.",
  1008: "Not enough links available. Please contact WaveXchange for further support.",
  1009: "Port Name is not valid.",
  999: "Group Name already exists.",
  1010: "You can not remove selected resource(s) as it seems under purchase by a buyer",
  1012: "Ports subscription has been already cancelled",
  1013: "Link subscription has been already cancelled",
  1014: "Port already deleted.",
  1015: "No available ports on switch",
  1016: "Network Resource in Cross Connect",
  1017: "Nearend and farend port already exist",
  1018: "Nearend port already exists",
  1019: "Farend port already exists",
};

export const SuccessMessage = {
  addPort: "Your Network Resource is added with WaveXchange.",
  addBandwidth: "Your have successfully added existing Link from NE1 to NE2.",
  unGroupedSuccess: "Ports are un-grouped successfully.",
  putForSaleSingleSuccess: "The Network resource has been successfully put up for sale in the MarketPlace.",
  putForSaleEditSuccess: "PORTNAME details are updated successfully for sell.",
  putBandwidthForSaleSuccess: "The Link has been successfully put up for sale in the MarketPlace.",
  addGroupSuccess: "Group created successfully.",
  editGroupSuccess: "Group details updated.",
  purchaseSuccess: "The network resource has been successfully purchased.",
  purchaseBandwidthSuccess: "The link has been successfully purchased.",
  removeFromMarketPlaceSuccess: "Network resource has been successfully removed from the MarketPlace.",
  removeFromMarketPlaceSuccessForBandwidth: "The link has been successfully removed from the MarketPlace.",
  putForSaleEditSuccessForBandwidth: "The Link details are updated successfully for sell.",
  crossConnectBulkSuccess: "Operation saved successfully.",
  crossConnectBulkFailed: "Operation failed, please try after sometime.",
  cancelSubscription: "Subscription cancelled successfully.",
  deletePort: "Port has been deleted successfully.",
  deleteMultiplePort: "Ports have been deleted successfully.",
  deleteBandwidth: "Link has been deleted successfully.",
  deleteMultipleBandwidth: "Links have been deleted successfully.",
  requestVerificationSuccessful: "Ports have been requested to join WaveXchange",
  editPort: "Your Network Resource has been edited successfully.",
  neAddedSuccess: "Network Element has been added successfully",
  neEditedSuccess: "Network Element has been edited successfully. Please refresh your page to see the changes in effect.",
};

export const ErrorCodesMapping = {
  1001: 1001,
  1002: 1002,
  1003: 1003,
  1004: 1004,
  1006: 1006,
  1007: 1007,
  999: 1008,
  1009: 1009,
  1010: 1010,
  1012: 1012,
  1013: 1013,
  1014: 1014,
  1015: 1015,
  1016: 1016,
  1017: 1017,
  1018: 1018,
  1019: 1019,
};

export const StatusCode = {
  Unauthorized: 401,
  ApiNotFound: 404,
  InternalServerError: 500,
};

export const ErrorMessages = {
  internalServerError: "Something went wrong.",
  unauthorized: "Session Expired, Please login again.",
  apiPathNotFound: "Requested API path not found.",
  portNameDescNotValid: "Port name and description are not valid",
  typeScriptError: "TypeScript Error",
};
